import { ComponentMapping, Container } from '@adobe/aem-react-editable-components';
import React from 'react';

import { CardContent } from '@/design-system/atoms/Cards/CardContent';
import { FeaturedCardsHero } from '@/design-system/molecules/FeaturedCardsHero';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

class IntegrationFeaturedCardsHero extends Container {
    constructor(props) {
        super(props);

        this.state = {
            componentMapping: this.props.componentMapping || ComponentMapping,
            expandedItems: this.props.expandedItems,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.activeIndexFromAuthorPanel !== undefined &&
            prevProps.activeIndexFromAuthorPanel !== this.props.activeIndexFromAuthorPanel
        ) {
            this.setState({
                expandedItems: [this.props.cqItemsOrder[this.props.activeIndexFromAuthorPanel]],
            });
        }
    }

    /**
     * Overriding the @aem-react-editable-components method to pass in
     * 'aemNoDecoration={true}' property to suppress wrapper divs
     * aem-react-editable-components/src/components/Container.tsx
     */
    connectComponentWithItem(ChildComponent, itemProps, itemKey) {
        const itemPath = this.getItemPath(itemKey);

        return (
            <ChildComponent
                {...itemProps}
                key={itemPath}
                cqPath={itemPath}
                aemNoDecoration={true}
                isInEditor={this.props.isInEditor}
                containerProps={this.getItemComponentProps(itemProps, itemKey, itemPath)}
            />
        );
    }

    render() {
        const { cards, appliedCssClassNames } = this.props;
        const theme = generateStyleModifiers(appliedCssClassNames).theme;

        const normalizeItems = Array.isArray(cards)
            ? cards.map((i, index) => (
                  <FeaturedCardsHero.Card key={index} fullHeight>
                      <CardContent
                          title={i.title}
                          body={i.body}
                          cta={{
                              href: i.href,
                              csr: i.csr,
                          }}
                          analyticsActionLabel={i.title}
                          analyticsComponentTitle={i.eyebrow}
                      />
                  </FeaturedCardsHero.Card>
              ))
            : [];

        const imageIllustrationTop = this.childComponents[0];
        const imageIllustrationBottom = this.childComponents[1];
        return (
            <FeaturedCardsHero
                {...this.props}
                items={normalizeItems}
                imageIllustrationTop={imageIllustrationTop}
                imageIllustrationBottom={imageIllustrationBottom}
                theme={theme}
            />
        );
    }
}

export default IntegrationFeaturedCardsHero;
